import { render } from "./CarStatusesView.vue?vue&type=template&id=078e2b8d&scoped=true&ts=true"
import script from "./CarStatusesView.vue?vue&type=script&lang=ts"
export * from "./CarStatusesView.vue?vue&type=script&lang=ts"

import "./CarStatusesView.vue?vue&type=style&index=0&id=078e2b8d&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078e2b8d"]])

export default __exports__